import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import pure from 'recompose/pure'

const styles = (theme) => ({
  item: {
    position: 'relative',
    minHeight: 40,
    paddingLeft: 7,
    cursor: 'pointer',
    transition: 'background 1s',
    marginBottom: 5,
    border: `1px solid ${theme.palette.borders.cloud}`,
    '&:hover': {
      background: theme.palette.secondary.main,
    },
  },
  pinterest: { '&:hover': { background: theme.palette.social.pinterest } },
  twitter: { '&:hover': { background: theme.palette.social.twitter } },
  instagram: { '&:hover': { background: theme.palette.social.instagram } },
  tumblr: { '&:hover': { background: theme.palette.social.tumblr } },
  googleplus: { '&:hover': { background: theme.palette.social.googleplus } },
  socialMediaName: {
    fontWeight: 300,
    position: 'absolute',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    height: '100%',
    color: theme.palette.text.main,
    transition: 'color 0.5s',
  },
  iconContainer: {
    paddingRight: 6,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    right: 0,
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: '1.2em',
    borderWidth: 2,
    opacity: 0.9,
    display: 'flex',
    alignItems: 'center',
    transition: 'opacity 0.5s',
  },
})

const SocialIcon = ({ Icon, url, title, className }) => {
  if (!Icon) {
    throw new Error('You must provide a social media icon.')
  }
  if (!url) {
    throw new Error('Please provide a URL to redirect to.')
  }

  return (
    <a href={url} target="_blank" style={{ margin: '0 4px' }} title={title}>
      <Icon className={className} />
    </a>
  )
}
SocialIcon.propTypes = {
  Icon: PropTypes.any.isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
}

const EnhancedSocialIcon = pure(SocialIcon)

const ConnectItem = ({ classes, Icon, url, title, onClick }) => (
  <div
    onClick={onClick}
    className={`${classes.item} ${
      classes[title.toLowerCase().replace(' ', '')]
    }`}
  >
    <Typography variant="body1" classes={{ body1: classes.socialMediaName }}>
      {title}
    </Typography>
    <div className={classes.iconContainer}>
      <EnhancedSocialIcon
        Icon={Icon}
        url={url}
        title={title}
        className={classes.icon}
      />
    </div>
    <style>{`
      .${classes.item}:hover .${classes.socialMediaName} {
        color: #fff;
      }
      .${classes.item}:hover .${classes.icon} {
        color: #fff;
      }
    `}</style>
  </div>
)

// prettier-ignore
export default compose(
  pure,
  withStyles(styles),
)(ConnectItem)



// WEBPACK FOOTER //
// ./src/components/Sidebar/ConnectItem.js